const content = {
    newyear: {
        url: "newyear",
        header: "A New Year (music video)",
        displayTitle: "A New Year",
        video: "",
        thumbnail: "https://live.staticflickr.com/65535/50208144398_e6159d9acb_k.jpg",
        album: "72157715436444986",
        sixteenNine: true
    },
    fallen: {
        url: "fallen",
        header: "The Fallen (feature)",
        displayTitle: "The Fallen",
        video: "388770525", //vimeo link id
        videoHost: 'vimeo',
        thumbnail: "https://live.staticflickr.com/65535/50208714186_4d58f0f266_k.jpg",
        album: "72157715437437658",
        sixteenNine: false,
    },  
    occult: {
        url: "occult",
        header: "The Occult (short film)",
        displayTitle: "The Occult",
        video: "",
        thumbnail: "https://live.staticflickr.com/65535/50209006287_da33fdd21a_k.jpg",
        album: "72157715435274906",
        sixteenNine: false,
    },
    lovestruth: {
        url: "lovestruth",
        header: "Love's Truth Behind (music video)",
        displayTitle: "Love's Truth Behind",
        video: "391693065",
        videoHost: 'vimeo',
        thumbnail: "https://live.staticflickr.com/65535/50208723206_90bbcc26f8_k.jpg",
        album: "72157715437288708",
        sixteenNine: false,
    },
    december: {
        url: "december",
        header: "December (short film)",
        displayTitle: "December",
        video: "390813222",
        videoHost: 'vimeo',
        thumbnail: "https://live.staticflickr.com/65535/50208199958_f09cc5c7b2_k.jpg",
        album: "72157715437186658",
        sixteenNine: false,
    },
    wiches: {
        url: "wiches",
        header: "Snitches Get Wiches (short film)",
        displayTitle: "Snitches Get Wiches",
        video: "",
        thumbnail: "https://live.staticflickr.com/65535/50208725981_aa3ffb8051_k.jpg",
        album: "72157715438246752",
        sixteenNine: false,
    },
    butterfly: {
        url: "butterfly",
        header: "Butterfly (short film)",
        displayTitle: "Butterfly",
        video: "387162188",
        videoHost: 'vimeo',
        thumbnail: "https://live.staticflickr.com/65535/50220736487_6bf925f764_k.jpg",
        album: "72157715467643243",
        sixteenNine: true,
    },
    yesno: {
        url: "yesno",
        header: "Yes/No (short film)",
        displayTitle: "Yes/No",
        video: "",
        thumbnail: "https://live.staticflickr.com/65535/50219876208_8b579a0fcb_k.jpg",
        album: "72157715467676103",
        sixteenNine: true,
    },
    idealconversation: {
        url: "idealconversation",
        header: "An Ideal Conversation (short film)",
        displayTitle: "An Ideal Conversation",
        video: "https://www.youtube.com/embed/UeVJnwMX5RU",
        videoHost: 'youtube',
        thumbnail: "https://live.staticflickr.com/65535/50395049843_94d04e201b_k.jpg", //comes from embed code
        album: "72157716167409576",
        sixteenNine: true,
    },
    oakmilk: {
        url: "oakmilk",
        header: "Oak Milk (short film)",
        displayTitle: "Oak Milk",
        video: "",
        videoHost: '',
        thumbnail: "https://live.staticflickr.com/65535/50397304353_d79b3603ef_k.jpg", //comes from embed code
        album: "72157716179489073",
        sixteenNine: true,
        isLoad: true,
    },
    palmtrees: {
        url: "palmtrees",
        header: "Palm Trees (music video)",
        displayTitle: "Palm Trees",
        video: "",
        videoHost: '',
        thumbnail: "https://live.staticflickr.com/65535/50929773916_3199fa9fcd_c.jpg", //comes from embed code
        album: "72157718236022866",
        sixteenNine: true,
        // isLoad: true,
    },
    pesos: {
        url: "pesos",
        header: "Pesos (music video)",
        displayTitle: "Pesos",
        video: "",
        videoHost: '',
        thumbnail: "https://live.staticflickr.com/65535/50929784106_2bf2131594_c.jpg",
        album: "72157718238870048",
        sixteenNine: true,
        // isLoad: true,
    },
}

export default content